(ns ui.legacy-subscription.page
  "Subscription page for legacy Paddle Classic customers. Shows plan
   details, payment info, invoices and allows cancellation or resuming
   a scheduled cancellation."
  (:require [parts.replicant.query :as query]
            [storrito.ui.core :as ui]
            [storrito.ui.spinner :as spinner]
            [ui.app-frame :as app-frame]
            [app.legacy-subscription.plans :as legacy-plans]))

(def legacy-subscription-query
  {:query/kind :query/legacy-subscription})

(def legacy-invoices-query
  {:query/kind :query/legacy-subscription-invoices})

(def resume-command
  {:command/kind :command/legacy-subscription-resume
   :command/data {}})

(defn render!
  [w]
  (app-frame/app-frame
    w
    (if (query/loading? w
                        legacy-subscription-query)
      [:span "loading..."]
      (let [result (query/get-result w
                                     legacy-subscription-query)
            paddle-classic-subscription (:organization/legacy-subscription result)
            cancel-for (:organization/legacy-subscription-cancel-for result)
            plan-id (:plan_id paddle-classic-subscription)]
        [:div
         [:div.mx-auto.max-w-2xl.space-y-16.sm:space-y-20.lg:mx-0.lg:max-w-none

          [:div
           [:h2 {:class ui/h2}
            "Customer (legacy)"]
           [:dl.mt-6.space-y-2.divide-y.divide-gray-100.border-t.border-gray-200.text-sm.leading-6

            [:div.pt-6.sm:flex
             [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Billing email address"]
             [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
              [:div.text-gray-900 (:user_email paddle-classic-subscription)]
              [:button {:class ui/a-indigo
                        :on {:click (fn []
                                      (js/alert "You are on a legacy plan. Please contact the support to change the email address."))}}
               "Change Email"]
              ]]
            [:div.pt-6.sm:flex
             [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Creation date"]
             [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
              [:div.text-gray-900 (:signup_date paddle-classic-subscription)]]]]]

          [:div
           [:h2 {:class ui/h2}
            "Subscription (legacy - unlimited Instagram seats)"]
           [:dl.mt-6.space-y-2.divide-y.divide-gray-100.border-t.border-gray-200.text-sm.leading-6

            [:div.pt-6.sm:flex
             [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Current plan"]
             [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
              [:div.text-gray-900 (get legacy-plans/plans plan-id) " (unlimited Instagram seats)"]
              [:button
               {:class ui/button-primary
                :on {:click [[:ui/modal-open
                              :modals/legacy-plan-info-modal
                              {}]]}}
               "Unlock new features!"]]]

            (if cancel-for
              [:div.pt-6.sm:flex
               [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Status"]
               [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
                [:div.text-gray-900 (str "Cancellation scheduled for "
                                         (.slice (.toISOString cancel-for) 0 10))]
                [:button {:class ui/button-primary
                          :on {:click [[:data/command
                                        resume-command
                                        {:on-success [[:js/location "/ui/legacy-subscription"]]}]]}}
                 "Resume subscription"]]]

              [:div.pt-6.sm:flex
               [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Status"]
               [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
                [:div (:state paddle-classic-subscription)]
                (when-not (= (:state paddle-classic-subscription)
                             "deleted")
                  [:button {:type "button"
                            :class ui/a-discrete
                            :on {:click [[:ui/modal-open :modals/subscription-cancel-modal
                                          {:legacy? true}]]}}
                   "Cancel subscription"])]])

            [:div.pt-6.sm:flex
             [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Payment Method"]
             [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto

              (let [payment-method-details (:payment_information paddle-classic-subscription)]
                (case (:payment_method payment-method-details)
                  "card" [:span
                          [:span
                           (case (:card_type payment-method-details)
                             "visa" [:i.fab.fa-cc-visa.fa-2xl.w-10.text-gray-500]
                             "master" [:i.fab.fa-cc-mastercard.fa-2xl.w-10.text-gray-500]
                             "american_express" [:i.fab.fa-cc-amex.fa-2xl.w-10.text-gray-500]
                             "discover" [:i.fab.fa-cc-discover.fa-2xl.w-10.text-gray-500]
                             "jcb" [:i.fab.fa-cc-jcb.fa-2xl.w-10.text-gray-500]
                             "diners_club" [:i.fab.fa-cc-diners-club.fa-2xl.w-10.text-gray-500]
                             "unionpay" [:i.fab.fa-cc-master.fa-2xl.w-10.text-gray-500]
                             [:i.fas.fa-credit-card.fa-2xl.w-10.text-gray-500])
                           "Card (" (:last_four_digits payment-method-details) ")"]

                          [:span.ml-4
                           [:i.fas.fa-clock.fa-lg.text-gray-500.w-6]
                           (:expiry_date payment-method-details)]]

                  "paypal" [:span [:i.fa-brands.fa-cc-paypal.fa-2xl.w-10.text-gray-500]
                            "Paypal"]
                  "alipay" [:span [:i.fa-brands.fa-alipay.fa-2xl.w-10.text-gray-500]
                            "Alipay"]
                  "apple_pay" [:span [:i.fa-brands.fa-cc-apple-pay.fa-2xl.w-10.text-gray-500]
                               "Apple Pay"]
                  "google_pay" [:span [:i.fa-brands.fa-google-pay.fa-2xl.w-10.text-gray-500]
                                "Google Pay"]
                  "wire_transfer" [:span "Wire Transfer"]

                  [:span (:payment_method payment-method-details)]))
              [:a
               {:class ui/a-indigo
                :target "_blank"
                :href (:update_url paddle-classic-subscription)}
               "Update"]]]

            (when-let [last-payment (:last_payment paddle-classic-subscription)]
              [:div.pt-6.sm:flex
               [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Last Payment"]
               [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
                [:span
                 (:amount last-payment) " " (:currency last-payment)
                 " at " (:date last-payment)]
                [:button
                 {:class ui/a-indigo
                  :target "_blank"
                  :on {:click [[:ui/modal-open
                                :modals/legacy-invoices-modal
                                {}
                                ]]}}
                 "Invoices"]]])

            (when-let [next-payment (:next_payment paddle-classic-subscription)]
              [:div.pt-6.sm:flex
               [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Next Payment"]
               [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
                (:amount next-payment) " " (:currency next-payment)
                " at " (:date next-payment)]])

            [:div.pt-6.sm:flex
             [:dt.font-medium.text-gray-900.sm:w-64.sm:flex-none.sm:pr-6 "Subscription ID"]
             [:dd.mt-1.flex.justify-between.gap-x-6.sm:mt-0.sm:flex-auto
              [:div.text-gray-900 (:subscription_id paddle-classic-subscription)]]]]]
          ]]))))

(defn invoice-item
  [{:keys [created_at receipt_url amount currency]}]
  [:div.mb-2
   {:style {:display "flex"
            :position "relative"
            :align-items "center"
            :flex "0 1 30%"
            :justify-content "space-between"}}
   [:p (take 10 created_at)]
   [:p amount " " currency]
   [:a
    {:class ui/a-indigo-bold
     :target "_blank"
     :href receipt_url}
    "Add your data / download"]])

(defn render-modal!
  [state]
  (let [query-result (query/get-result state
                                       legacy-invoices-query)]
    [:div.mt-6
     (if (query/loading? state
                         legacy-invoices-query)
       (spinner/vire-spinner-sm)
       (map
         (fn [invoice]
           (invoice-item invoice))
         (:invoices query-result)))]))

(def page
  {:page-id :pages/legacy-subscription
   :route [["ui" "legacy-subscription"]]
   :on-load (fn [_location]
              [[:legacy-subscription/redirect-if-not-legacy]
               [:data/query legacy-subscription-query]])
   :render #'render!})

(def modal
  {:modal-id :modals/legacy-invoices-modal
   :on-load (fn [_location]
              [[:data/query legacy-invoices-query]])
   :render #'render-modal!})

(def legacy-plan-support-message
  "Hi, I'm on a legacy Storrito plan and I'm interested in switching to the new pricing to get access to new features like AI image generation. I'd like to learn more about the discount you offer for legacy customers.")

(defn render-legacy-plan-info-modal!
  [_state]
  [:div.py-4.flex.flex-col.items-center
   [:h3.text-lg.font-semibold.text-gray-900.text-center.mb-6
    "Unlock New Features"]
   [:p.text-sm.text-gray-700.text-center.mb-6
    "Switch to our new pricing to get access to exciting new features:"]
   [:div.space-y-4.mb-8
    [:div.flex.items-start.gap-3
     [:i.fas.fa-wand-magic-sparkles.text-indigo-500.mt-0.5]
     [:p.text-sm.text-gray-700
      "AI image generation"]]
    [:div.flex.items-start.gap-3
     [:i.fa-brands.fa-tiktok.text-indigo-500.mt-0.5]
     [:p.text-sm.text-gray-700
      "TikTok video posting"]]
    [:div.flex.items-start.gap-3
     [:i.fa-brands.fa-youtube.text-indigo-500.mt-0.5]
     [:p.text-sm.text-gray-700
      "YouTube Shorts posting"]]
    [:div.flex.items-start.gap-3
     [:i.fas.fa-rocket.text-indigo-500.mt-0.5]
     [:p.text-sm.text-gray-700
      "And more features to come"]]]
   [:p.text-sm.text-gray-700.text-center.mb-6
    "Contact support to learn about the special discount we offer for legacy customers."]
   [:div.flex.gap-3.justify-end
    [:button.px-4.py-2.text-sm.font-medium.rounded-full.border.border-gray-300.text-gray-700.bg-white.hover:bg-gray-50
     {:on {:click [[:ui/modal-close]]}}
     "Close"]
    [:button.px-4.py-2.text-sm.font-medium.rounded-full.text-white.bg-indigo-600.hover:bg-indigo-700
     {:on {:click [[:crisp/open-chat]
                   [:crisp/set-message-text legacy-plan-support-message]
                   [:ui/modal-close]]}}
     [:i.fas.fa-comments.mr-2]
     "Contact Support"]]])

(def legacy-plan-info-modal
  {:modal-id :modals/legacy-plan-info-modal
   :render #'render-legacy-plan-info-modal!})

